import styled from "@emotion/styled";

interface WarningBoxWrapperProps {
	isInfo?: boolean;
}

export const WarningBoxWrapper = styled.div<WarningBoxWrapperProps>(({ theme, isInfo }) => ({
	position: "relative",
	color: isInfo ? theme.project.colors.primaryColors.main : theme.project.colors.semanticColors.warning,
	backgroundColor: isInfo
		? theme.project.colors.backgroundColors.info
		: theme.project.colors.backgroundColors.warning,
	svg: {
		position: "absolute",
		top: "13px",
		left: "8px",
		width: "22px",
		height: "22px"
	},
	"& > div": {
		padding: "14px 8px 14px 42px",
		display: "flex",
		flexDirection: "column",
		gap: "4px",
		"& > span": theme.project.typography.alert.alertTitle,
		"& > p, & > div": {
			...theme.project.typography.alert.alertDescription,
			display: "block"
		},
		a: {
			...theme.project.typography.alert.alertDescription,
			color: isInfo ? theme.project.colors.primaryColors.main : theme.project.colors.semanticColors.warning
		}
	}
}));
